import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'Landing',
      path: '/',
      component: () => import('@/views/Landing'),
    },
    {
      name: 'PublicProfile',
      path: '/profile/:token',
      component: () => import('@/views/PublicProfile'),
      meta: { public: true },
    },
    {
      path: '/app',
      component: () => import('@/views/dashboard/Index'),
      children: [
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'ShikakuList',
          path: '/list',
          component: () => import('@/views/dashboard/ShikakuList'),
        },
        {
          name: 'Timeline',
          path: '/timeline',
          component: () => import('@/views/dashboard/Timeline'),
        },
        {
          name: 'Privacy',
          path: '/privacy',
          component: () => import('@/views/dashboard/Privacy'),
          meta: { public: true },
        },
        {
          name: 'Terms',
          path: '/terms',
          component: () => import('@/views/dashboard/Terms'),
          meta: { public: true },
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  const loggedIn = store.state.user.login === true
  // ログイン済みでトップ（LP）にアクセスしたらアプリへリダイレクト
  if (loggedIn && to.name === 'Landing') {
    next({ path: '/app' })
    return
  }
  if (!loggedIn) {
    if (to.name === 'Landing' || to.meta.public) {
      next()
    } else {
      next({ path: '/' })
    }
  } else {
    next()
  }
})

export default router
